import { CreateAdsWithCreativesOperationStatus } from '../../../../../apis/graphql/types';
import type { TagSheetSaveAdItem, TagSheetSaveCreativeItem } from '../types';

type TagSheetSaveAdEntity = TagSheetSaveAdItem['adEntity'];
type TagSheetSaveSuccessfulAdEntity = Extract<TagSheetSaveAdEntity, { __typename?: 'AdV5' }>;
type TagSheetSaveFailedAdEntity = Extract<
  TagSheetSaveAdEntity,
  { __typename?: 'CreateAdsWithCreativesFailedAdEntity' }
>;
type TagSheetSaveFailedCreativeEntity = Extract<
  TagSheetSaveCreativeItem['creativeEntity'],
  { __typename?: 'CreateAdsWithCreativesFailedCreativeEntity' }
>;

export const isAdEntitySuccess = (entity: TagSheetSaveAdEntity): entity is TagSheetSaveSuccessfulAdEntity =>
  entity.__typename === 'AdV5';

export const isAdEntityFailed = (entity: TagSheetSaveAdEntity): entity is TagSheetSaveFailedAdEntity =>
  entity.__typename === 'CreateAdsWithCreativesFailedAdEntity';

export const isFailedCreativeEntity = (
  entity: TagSheetSaveCreativeItem['creativeEntity'] | undefined
): entity is TagSheetSaveFailedCreativeEntity => entity?.__typename === 'CreateAdsWithCreativesFailedCreativeEntity';

export const isCreativeItemSuccess = (item: TagSheetSaveCreativeItem): boolean =>
  item.operationStatus === CreateAdsWithCreativesOperationStatus.Success &&
  Boolean(item.creativeEntity) &&
  !isFailedCreativeEntity(item.creativeEntity);

export const isCreativeItemFailed = (item: TagSheetSaveCreativeItem): boolean =>
  item.operationStatus === CreateAdsWithCreativesOperationStatus.Failed || isFailedCreativeEntity(item.creativeEntity);

export const isAdSuccessfullyCreated = (adItem: TagSheetSaveAdItem): boolean =>
  adItem.operationStatus === CreateAdsWithCreativesOperationStatus.Success &&
  isAdEntitySuccess(adItem.adEntity) &&
  Boolean(adItem.adEntity.id);

export const isCreativeSuccessfullyCreated = (creativeItem: TagSheetSaveCreativeItem): boolean => {
  const { creativeEntity } = creativeItem;

  return (
    creativeItem.operationStatus === CreateAdsWithCreativesOperationStatus.Success &&
    Boolean(creativeEntity) &&
    !isFailedCreativeEntity(creativeEntity) &&
    'id' in creativeEntity &&
    Boolean(creativeEntity.id)
  );
};
